import { FormattedMessage, MessageDescriptor } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { BodyM } from 'atoms/typography';

interface Props {
  message: MessageDescriptor;
}
const GreyStripes = styled(Horizontal).attrs({ gap: 0, center: true })`
  color: var(--c-nd-600);
  height: 60px;
  background: repeating-linear-gradient(
    -45deg,
    var(--c-black),
    var(--c-black) 1px,
    var(--c-nd-200) 1px,
    var(--c-nd-200) 2px
  );
  border-radius: var(--unit);
`;

export const EmptyContent = (props: Props) => {
  const { message } = props;

  return (
    <GreyStripes>
      <BodyM>
        <FormattedMessage {...message} />
      </BodyM>
    </GreyStripes>
  );
};
